import { render, staticRenderFns } from "./DashboardRepresentative.vue?vue&type=template&id=13cb3c17"
import script from "./DashboardRepresentative.vue?vue&type=script&lang=js"
export * from "./DashboardRepresentative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports